import { Row, Col, FormControl, InputGroup } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'

function Filtro({t, catName}){
    return(<>
        <Row className="align-items-center">
            <Col xs="12" md="9">
                <h3 className="titulo">{ t('catalogos') } - <span className="resaltado">{catName}</span></h3>
            </Col>
        </Row>
    </>)
}

export default withTranslation()(Filtro)